import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { UsePaginationState } from '@uhg-abyss/web/hooks/usePagination';
import { Pagination as PaginationComponent } from '@uhg-abyss/web/ui/Pagination';
import React from 'react';

import { Styles } from './includes/styles';

/**
 * NumberedPagination
 *
 * Displays a pagination control for next/previous pages along with controls to navigate to a specific page number.
 */
export function NumberedPagination(props: UsePaginationState) {
  return (
    <ErrorHandler location="src/shared/ui/components/TableQuery/components/Footer/components/NumberedPagination/NumberedPagination.tsx">
      <Styles>
        <PaginationComponent {...props} />
      </Styles>
    </ErrorHandler>
  );
}
